import React from 'react';
import CrmLabelsPage from '../components/CrmLabelsPage';

const CrmLabelsApp = (props) => (
  <CrmLabelsPage {...props} />
);

export default CrmLabelsApp;
